import { StrapiComponentType } from "@/src/type";
import { ObjectHelper } from "../util";

function checkAndMergeVariant(original: any, componentId?: string, variants?: Record<string, StrapiComponentType.Object.ContentVariantItem<any>>) {
  if (!variants || !componentId) {
    return original;
  }

  const variant = variants[componentId];
  if (!variant) {
    return original;
  }
  return ObjectHelper.deepMerge(original, variant.variant);
}

export default {
  checkAndMergeVariant,
};
